import React, { Component, createRef } from 'react';
import { Grid } from '@material-ui/core';
import {
    SofaCheckbox,
    AbstractSofaForm,
    SofaFormWithGtm,
    SofaFormControl,
    checkboxValueToBooleanFilter,
    checkboxRequiredValidator,
    SofaFormControlDescriptionWithGtm,
    getPropsForSofaInput
} from '@sofology/sofologycomponents';
import { SofaFormComponent } from 'interfaces';
import { DataProtectionNoticeFormData } from '../DataProtectionNoticePage';
import { analyticsHelper, errorToBasketErrorModel } from 'helpers';

export const CONFIRMATION_REQUIRED_ERROR_MESSAGE = 'Please check the box to confirm your understanding and agreement with the statement above.';
const GTM_FORM_NAME = 'dpn';

interface OwnProps {
    ref?: React.RefObject<DataProtectionNoticeForm>;
}

interface OwnState {
    dataProtectionNoticeForm: SofaFormWithGtm<DataProtectionNoticeControls>;
}

interface DataProtectionNoticeControls extends AbstractSofaForm {
    confirmFinancialAssociatesAgreement: SofaFormControl<boolean>;
}

class DataProtectionNoticeForm extends Component<OwnProps, OwnState> implements SofaFormComponent<DataProtectionNoticeFormData> {
    constructor(props: OwnProps) {
        super(props);

        this.state = {
            dataProtectionNoticeForm: new SofaFormWithGtm<DataProtectionNoticeControls>(
                {
                    confirmFinancialAssociatesAgreement: {
                        name: 'confirmFinancialAssociatesAgreement',
                        defaultValue: false,
                        filters: [checkboxValueToBooleanFilter()],
                        validators: [checkboxRequiredValidator(CONFIRMATION_REQUIRED_ERROR_MESSAGE)],
                        ref: createRef<SofaCheckbox>(),
                        gtmFieldName: 'financialAssociatesAgreement'
                    } as SofaFormControlDescriptionWithGtm<boolean>
                },
                updateStateFunc => {
                    this.setState(updateStateFunc);
                },
                'dataProtectionNoticeForm',
                () => this.state,
                GTM_FORM_NAME,
                analyticsHelper.sendToGoogleMessageAboutInputChangeCompleted.bind(analyticsHelper),
                errorToBasketErrorModel
            )
        };
    }

    render(): JSX.Element {
        return (
            <div className='data-protection-notice-form'>
                <Grid container>
                    <Grid item xs={12}>
                        <SofaCheckbox
                            label='I have read and understood the Data Protection & Credit Brokerage Notice and wish to proceed with the application for credit.'
                            {...getPropsForSofaInput(this.state.dataProtectionNoticeForm.controls.confirmFinancialAssociatesAgreement)}
                            helperText={null}
                        />
                    </Grid>
                </Grid>
            </div>
        );
    }

    public getFormData(): DataProtectionNoticeFormData {
        return {
            confirmFinancialAssociatesAgreement: this.state.dataProtectionNoticeForm.controls.confirmFinancialAssociatesAgreement.value
        };
    }

    public validate = (): Promise<SofaFormControl<any>[]> => {
        return this.state.dataProtectionNoticeForm.validate();
    };
}

export default DataProtectionNoticeForm;
export type DataProtectionNoticeFormType = DataProtectionNoticeForm;